import * as React from 'react';
import PropTypes from 'prop-types';

class ScoreBoard extends React.Component {
    constructor(props) {
        super(props);

        this.calculateScores = this.calculateScores.bind(this);
    }

    render() {
        let scores = this.calculateScores();

        return (
            <div className="scoreBoard col-sm-6 px-0">
                <h2>Tabela Scor</h2>

                <table border="1" className="table table-striped table-hover table-borderless">
                    <thead className="thead-dark">
                    <tr className="small">
                        <th style={{maxWidth: "20px"}} className="align-middle">&nbsp;</th>
                        { this.props.players.map(function (name, index) {
                            if (name == 'madalin' || name == 'Madalin' || name == 'mdl' || name == 'mad') {
                                return <th key={ index } colSpan="2"><strong>⭐ { name }</strong></th>
                            } else {
                                return <th key={ index } colSpan="2"><strong>{ name }</strong></th>
                            }
                        }) }
                    </tr>
                    </thead>
                    <tbody>
                    { this.props.rounds.map((round, roundNo) => {
                        return (
                            <tr key={ roundNo }>
                                <td className="table-secondary text-center small">{ round }</td>

                                { this.props.players.map(function (name, playerNo) {
                                    let score = scores[roundNo][playerNo];
                                    let bidClasses = ["bid"];

                                    if (score.wrong) {
                                        bidClasses.push("wrong");
                                    }

                                    if (score.positivePrize) {
                                        bidClasses.push("positivePrize");
                                    }

                                    if (score.negativePrize) {
                                        bidClasses.push("negativePrize");
                                    }

                                    return [
                                        <td key={ 'bid' + playerNo } className={ bidClasses.join(" ") }>
                                            { score.bid }
                                        </td>,
                                        <td key={ 'score' + playerNo } className="table-secondary bg-info text-white">
                                            <strong>{ score.score }</strong>
                                        </td>
                                    ];
                                }) }
                            </tr>
                        );
                    }) }
                    </tbody>
                </table>
            </div>
        );
    }

    /**
     * Returns an array of type:
     * scores[round][player] = {
     *   bid: 2,
     *   score: 50,
     *   wrong: false,
     *   positivePrize: true,
     *   negativePrize: false
     * }
     *
     * @return array
     */
    calculateScores() {
        let scores = [];
        let totalRounds = this.props.rounds.length;
        let totalPlayers = this.props.players.length;

        for (let player = 0; player < totalPlayers; player++) {
            let wonInARow = 0;
            let lostInARow = 0;
            let score = 0;

            for (let round = 0; round < totalRounds; round++) {
                let bid;
                let wrong = false;
                let positivePrize = false;
                let negativePrize = false;

                if (this.props.history[round] && this.props.history[round]['scores']) {
                    bid = this.props.history[round]['bids'][player];
                    let actual = this.props.history[round]['scores'][player];
                    let cardsPerRound = this.props.rounds[round];

                    if (bid === actual) {
                        score += 5 + bid;
                        lostInARow = 0;

                        if (cardsPerRound > 1) {
                            wonInARow++;
                        }

                        if (wonInARow === 5) {
                            score += 10;
                            positivePrize = true;
                            wonInARow = 0;
                        }
                    } else {
                        score -= Math.abs(bid - actual);
                        wrong = true;
                        wonInARow = 0;

                        if (cardsPerRound > 1) {
                            lostInARow++;
                        }

                        if (lostInARow === 5) {
                            score -= 10;
                            negativePrize = true;
                            lostInARow = 0;
                        }
                    }
                } else {
                    score = null;

                    if (this.props.history[round]) {
                        bid = this.props.history[round]['bids'][player];
                    }
                }

                if (!scores[round]) {
                    scores[round] = [];
                }

                scores[round][player] = {
                    bid: bid,
                    score: score,
                    wrong: wrong,
                    positivePrize: positivePrize,
                    negativePrize: negativePrize,
                };
            }
        }

        return scores;
    }
}

ScoreBoard.propTypes = {
    history: PropTypes.arrayOf(PropTypes.object).isRequired,
    players: PropTypes.arrayOf(PropTypes.string).isRequired,
    rounds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default ScoreBoard;



// WEBPACK FOOTER //
// ./src/components/ScoreBoard.js